import https from "@/lib/https";
import type {
  CertificationDetail,
  CertificationPayload,
  GetCertificationListParams,
} from "@/interface/profile";
import type { ApiResponse } from "@/interface/common";

const BASE_URL = "/api/certifications/";

export const getCertificationList = async (
  params?: GetCertificationListParams,
): Promise<ApiResponse<CertificationDetail[]>> => {
  return await https.get<ApiResponse<CertificationDetail[]>>(BASE_URL, params);
};

export const getCertificationById = async (
  id: number | string,
): Promise<ApiResponse<CertificationDetail>> => {
  return await https.get<ApiResponse<CertificationDetail>>(`${BASE_URL}${id}/`);
};

export const createCertification = async (
  payload: CertificationPayload,
): Promise<ApiResponse<CertificationDetail>> => {
  return await https.post<ApiResponse<CertificationDetail>>(BASE_URL, payload);
};

export const updateCertification = async (
  id: number | string,
  payload: CertificationPayload,
): Promise<ApiResponse<CertificationDetail>> => {
  return await https.put<ApiResponse<CertificationDetail>>(
    `${BASE_URL}${id}/`,
    payload,
  );
};

export const patchCertification = async (
  id: number | string,
  payload: Partial<CertificationPayload>,
): Promise<ApiResponse<CertificationDetail>> => {
  return await https.patch<ApiResponse<CertificationDetail>>(
    `${BASE_URL}${id}/`,
    payload,
  );
};

export const deleteCertification = async (
  id: number | string,
): Promise<ApiResponse<void>> => {
  return await https.delete<ApiResponse<void>>(`${BASE_URL}${id}/`);
};
